import { render } from "./PaintSwitchSideOnly.vue?vue&type=template&id=22df00dc&scoped=true"
import script from "./PaintSwitchSideOnly.vue?vue&type=script&lang=js"
export * from "./PaintSwitchSideOnly.vue?vue&type=script&lang=js"

import "./PaintSwitchSideOnly.vue?vue&type=style&index=0&id=22df00dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22df00dc"]])

export default __exports__